import { MotifCard, MotifCardBody, MotifIcon } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import ConversationOptionSelect from './ConversationOptionSelect';
import ConversationFileSelect from './ConversationFileSelect';
import ConversationMessageReply from './ConversationMessageReply';
import ConversationParseingDocument from './ConversationParseingDocument';
import ConversationSuccessfullyUploadedDocument from './ConversationSuccessfullyUploadedDocument';
import ConversationSuccessfullyParsedDocument from './ConversationSuccessfullyParsedDocument';
import ConversationInfoWithMessage from './ConversationInfoWithMessage';
import { convertTimestampToReadableFormat } from '../../helpers/util';
import ViewQuostionnaireDialog from './ViewQuostionnaireDialog';
import { BotUser } from 'src/config/assets';
import Image from '../atoms/Image';
import ConversationChoosePreferredResponseText from './ConversationChoosePreferredResponseText';
import { useDispatch } from 'react-redux';

const ChatMessage = (props: any) => {
    const { message, timeStamp, type, enabledToAnswer } = props;
    const dispatch = useDispatch();

    const updateContent = useCallback((content: any, component) => {
        dispatch({ type: "CONVERSATION_UPDATE_CONTENT", payload: { content, component } })
    }, [])

    const renderMesage = useCallback(() => {
        
        if (message.text) {
            return (
                <MotifCard>
                    <MotifCardBody>
                        <p className="motif-body1-default-light">
                            {message.text}
                        </p>
                    </MotifCardBody>
                </MotifCard>
            )
        }
        if (message.component) {
            const { component, content, requestParams } = message;
            if (component === "option-select") {
                return <ConversationOptionSelect content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "file-select") {
                return <ConversationFileSelect content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "message-reply") {
                return <ConversationMessageReply content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "parsing-document") {
                return <ConversationParseingDocument content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "successfully-uploaded-document") {
                return <ConversationSuccessfullyUploadedDocument content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "successfully-parsed-document") {
                return <ConversationSuccessfullyParsedDocument content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "info-with-action") {
                return <ConversationInfoWithMessage content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "success-message") {
                return <ConversationMessageReply content={content} enabledToAnswer={enabledToAnswer} />
            }
            if (component === "table-view-dialog") {
                return <ViewQuostionnaireDialog content={content} updateContent={(cnt: any) => updateContent(cnt, message.component)} enabledToAnswer={enabledToAnswer} requestParams={requestParams}  />
            }
            if (component === "choose-preferred-response-text") {
                return <ConversationChoosePreferredResponseText content={content} enabledToAnswer={enabledToAnswer} requestParams={requestParams}  />
            }
        }
        return <></>;
    }, [enabledToAnswer])
    return (
        <div className="mb-5">
            <div className={`flex gap-6 ${type === "sent" && "flex-row-reverse"}`}>
                {type === "received" && (
                    <div>
                       <Image alt="Bot User" src={BotUser} />
                    </div>
                )}
                <div style={{ minWidth: type === "received" ? "40%" : "0", maxWidth: "70%" }}>
                <p className={`
                    motif-overline-default-regular mb-2 ${type !== "received" && "text-right"}
                `}>{convertTimestampToReadableFormat(timeStamp)}</p>
                    {renderMesage()}
                </div>
            </div>
        </div>
    )
}

export default ChatMessage